import fifthaveClient from './fifthaveClient';

export function getRecordedBrandsList(data) {
  return fifthaveClient.get('/api/v2/brand/list', {
    params: data
  });
}

export function changeBrandStatus(brandId, status) {
  return fifthaveClient.patch(`/api/v2/brand/${brandId}/switch?status=${status}`);
}

export function deleteBrand(brandId) {
  return fifthaveClient.delete(`/api/v2/brand/${brandId}`);
}

export function getCountryCode() {
  return fifthaveClient.get('/api/v1/areacode');
}

export function getMerchantBrandsList(data) {
  return fifthaveClient.get('/api/v1/merchantBrands/list', {
    params: data
  });
}
// 解绑
export function unbindBrand(brandId) {
  return fifthaveClient.patch(`/api/v1/merchantBrands/${brandId}/switch?status=false`);
}

// 获取可以绑定的商家品牌
export function getBindableMerchantBrand() {
  return fifthaveClient.get('/api/v1/merchantBrands/withBinds');
}

// 获取可以绑定的管理品牌
export function getBindableBrand(keyword) {
  return fifthaveClient.get('/api/v1/brands', {
    params: {
      np: keyword,
      reload: true,
      timestamp: Number(new Date())
    }
  });
}
// 绑定品牌
export function bindBrand(brandId, otherNames) {
  return fifthaveClient.patch(`/api/v2/brand/${brandId}`, {
    id: brandId,
    otherNames
  });
}

// 新增品牌
export function newBrand(data) {
  return fifthaveClient.post(`/api/v2/brand`, data);
}

// 更新品牌
export function updateBrand(brandId, data) {
  return fifthaveClient.patch(`/api/v2/brand/${brandId}`, data);
}

// 根据id获取品牌详情
export function getBrandDetail(brandId) {
  return fifthaveClient.get(`/api/v1/brands/${brandId}`);
}

// 关键字查询品牌
export function getbrandsByText(text) {
  text = encodeURIComponent(text)
  return fifthaveClient.get(`/api/v1/brands?np=${text}&_all=true`)
}

// 上传品牌logo
export function postBrandLogo(data) {
  return fifthaveClient.post('/api/v1/brandImage/icon/_upload', data);
}

// 根据品牌id列表获取品牌信息
export function getBrandListByIds(ids) {
    const idStr = 'id=' + ids.join('&id=');
    return fifthaveClient.get(`/api/v1/brands/_batch?${idStr}&field=name`)
}

// 获取所有品牌信息
export function getAllBrands() {
    return fifthaveClient.get(`/api/v2/brand/withBinds`)
}

// 批量更新商品品牌
export function updateManualBrand(data) {
  return fifthaveClient.post('/api/v1/products/_batch/manual/brand-id', data)
}

// 获取商品品牌更改记录
export function getBrandRecord(id) {
  return fifthaveClient.get(`/api/v1/_internal/auditactions/fifthave.product_update_manual/${id}_brand_id`)
}